import React from "react"
import { FlagIcon } from "shared/icons"

const FormSubmissionFlagging = () => (
  <FlagIcon className="lg:mb-1" />
)

export default FormSubmissionFlagging
